import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';

import { IGetSettingsResponse, ISaveSettingsRequest, UpdateSettings } from 'models/http/setting';
import { prepareQPFromFilters, serverAxios } from '../../http';
import { AxiosResponse } from 'axios';
import { SettingsCategories, SettingsEntityTypes } from 'models/settings';
import { SettingsTemplatesType } from 'utils/enums/settings';

class SettingHttp {
  private static route = '/settings';

  public async get(data: {
    entityType: SettingsEntityTypes;
    profileId?: string | null;
    ignoreTemplates?: boolean;
    routeTemplateId?: string | null;
    assignTemplateId?: string | null;
    accessToken?: string;
    abortController?: AbortController;
  }): Promise<IGetSettingsResponse> {
    const query = prepareQPFromFilters({
      entityType: data.entityType,
      ignoreTemplates: data.ignoreTemplates,
      ...(data.profileId && data.entityType === SettingsEntityTypes.Profile ? { profileId: data.profileId } : null),
      ...(data.routeTemplateId && data.entityType === SettingsEntityTypes.Templates ? { routeTemplateId: data.routeTemplateId } : null),
      ...(data.assignTemplateId && data.entityType === SettingsEntityTypes.Templates ? { assignTemplateId: data.assignTemplateId } : null),
    });

    return serverAxios
      .get(`${SettingHttp.route}?${query}`, {
        signal: data.abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
        headers: {
          Authorization: `Bearer ${data.accessToken}`,
        },
      })
      .then((response: AxiosResponse<IGetSettingsResponse>) => response.data);
  }

  public async save(
    settings: UpdateSettings[],
    entityType: SettingsEntityTypes,
    profileId?: number,
    templateId?: number | null,
    templateType?: SettingsTemplatesType | null,
  ): Promise<void> {
    const body: ISaveSettingsRequest = { settings, entityType };

    if (profileId) {
      body.profileId = profileId;
    }

    if (templateId && entityType === SettingsEntityTypes.Templates) {
      body.templateId = templateId;
    }

    if (templateType && (entityType === SettingsEntityTypes.Site || entityType === SettingsEntityTypes.Templates)) {
      body.templateType = templateType;
    }

    return serverAxios
      .patch(SettingHttp.route, body, {
        timeout: HttpTimeoutPriority.Medium,
      })
      .then(() => {
        return;
      });
  }

  public async resetSettings(
    entityType: SettingsEntityTypes,
    category: SettingsCategories,
    profileId?: number,
    templateId?: number,
  ): Promise<void> {
    return serverAxios
      .delete(`${SettingHttp.route}/reset`, {
        timeout: HttpTimeoutPriority.Medium,
        data: {
          entityType,
          category,
          profileId,
          templateId,
        },
      })
      .then(() => {
        return;
      });
  }

  public async systemInfo(act: string): Promise<AxiosResponse<{ settings: unknown[] }>> {
    return serverAxios
      .post(
        SettingHttp.route,
        {
          act,
        },
        {
          timeout: HttpTimeoutPriority.Medium,
        },
      )
      .then((response: AxiosResponse<{ settings: unknown[] }>) => {
        return response;
      });
  }
}

export default SettingHttp;
